import { Reducer } from "react";
import { ALERTS_REDUX } from "../../constants";
import { AlertActions, AlertsInterface } from "./types";

export const initialState:AlertsInterface = {
    success : {
        visible: false,
        message: ''
    },
    error: {
        visible: false,
        message: ''
    },
    dialog: {
        visible: false,
        title: '',
        message: '',
        closeBtn: ''
    },
    loader: {
        visible: false
    },
    backdrop: {
        visible: false
    }
}


export const alertsReducer: Reducer<AlertsInterface, AlertActions> = (state = initialState, { type, ...payload }) => {
    switch (type) {
        case ALERTS_REDUX.SHOW_SUCCESS_ALERT:
            return {
                // @ts-ignore
                ...state,
                // @ts-ignore
                success: payload.payload
            };
        case ALERTS_REDUX.SHOW_ERROR_ALERT:
            return {
                ...state,
                // @ts-ignore
                error: payload.payload
            };
        case ALERTS_REDUX.SHOW_DIALOG_BOX:
            return {
                ...initialState
            };
        case ALERTS_REDUX.SHOW_LOADER:
            return {
                ...state,
                loader: {visible:true}
            };
        case ALERTS_REDUX.HIDE_LOADER:
            return {
                ...state,
                loader: {visible:false}
            };
        case ALERTS_REDUX.SHOW_BACKDROP:
            return {
                ...state,
                backdrop: {visible:true}
            };
        case ALERTS_REDUX.HIDE_BACKDROP:
            return {
                ...state,
                backdrop: {visible:false}
            };
        default:
            return {
                ...state
            };
    }
};
